import { render, staticRenderFns } from "./foods.page.vue?vue&type=template&id=2b945c6a&"
import script from "./foods.page.vue?vue&type=script&lang=js&"
export * from "./foods.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports